export enum AuthPersonBillingActions {
  REGISTER,
}
